module.exports = __webpack_public_path__ + "static/media/cma-logo0.9483453b.png";